import useSWR from "swr";
import Layout from "../../../components/custom/Layout";
import useUser from "../../../customHooks/useUser";
import { customFetcher, getTsDate, notify } from "../../../utils";
import { ChoiceEmployee } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import useModal from "../../../customHooks/useModal";
import ModalConfirm from "./ModalConfirm";
import apiClient from "../../../apiClient";
import { useEffect, useState } from "react";

export default function EndUserAccess () {

    const { user } = useUser();
    const {
        data,
        mutate
    } = useSWR(`/end-user-access/${user.s_unit}`, customFetcher<ChoiceEmployee>);
    const [id, setId] = useState(null);
    const { modal, setModal } = useModal();

    const handleRevokeAccess = (id: number) => {
        setId(id);
        setModal(true);
    }

    const confirm = async () => {
        await apiClient.put(`/end-user-access`, {
            id,
            s_modified_by: user.s_email,
            t_modified: getTsDate()
        });
        setModal(false);
        mutate(prev => {
            const updated = prev.filter(item => item.id !== id);
            return updated;
        });
        notify('Success');
    }

    return (
        <Layout>
            <h1>End User Access</h1>
            <VirtualTable<ChoiceEmployee> 
                data={data}
                mapping={[{
                    name: 'First Name',
                    value: 's_first_name'
                }, {
                    name: 'Last Name',
                    value: 's_last_name'
                }, {
                    name: 'Email',
                    value: 's_email'
                }, {
                    name: 'Job title',
                    value: 's_job_title'
                }, {
                    name: '',
                    value: 'fas fa-trash',
                    icon: true,
                }]}
                handleClick={item => handleRevokeAccess(item.id)}
            />
            <ModalConfirm 
                modal={modal}
                setModal={setModal}
                confirm={confirm}
            />
        </Layout>
    );
}